import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pn3my95u2u: FaireBrandEntity = {
  token: "b_pn3my95u2u",
  type: "brand",
  name: "Oddly Specific",
  avatarUrl:
    "https://cdn.faire.com/fastly/3a9989e555f8ad2f13c01f335c543f2e20a96a22024f671ea0e147481819772e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5fd43d811a20ece3cc2f29204ceff6523e7b448ce8b3a394b09adce28d4f84c2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3a9989e555f8ad2f13c01f335c543f2e20a96a22024f671ea0e147481819772e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5fd43d811a20ece3cc2f29204ceff6523e7b448ce8b3a394b09adce28d4f84c2.jpeg",
  location: "Kelowna, BC, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: false,
  description:
    "Oddly Specific is an ongoing expression in creativity, nature and texture — manifested through art you can wear and intentional objects for your home. ",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:18.610Z",
    importedBy: "entity-db-cli",
  },
};
